import React from 'react';

import { FormattedMessage } from 'react-intl';


import { style } from 'glamor';

const InvalidProductListItem = () => (
  <div {...style({
    width: '100%',
    paddingBottom: '100%',
    position: 'relative',
    backgroundColor: '#fff',
  })}>
    <div {...style({
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      fontSize: '14px',
      padding: '10px',
      top: '0',
      bottom: '0',
      right: '0',
      left: '0',
    })}>
      <FormattedMessage
        id="ProductListItem.cannotBeDisplayed"
        description="Shown on a product in a list, if it can't be shown for some reason"
        defaultMessage="This product cannot be displayed." />
    </div>
  </div>
);

export default InvalidProductListItem;



// WEBPACK FOOTER //
// ../src/client/components/ProductList/InvalidProductListItem.js